import React from 'react'
import {Switch,Route,Redirect} from 'react-router-dom'
import routerList from './routerList'
import NavigationBar from '../pages/navigationBar'
import Home from '../pages/home'
const IndexRouter = ()=>{
    return (
        <Switch>
            <NavigationBar>
            <Route 
                path='/'
                exact
                component={Home}
            />
            <Route 
                path='/heritage/culture'
                exact
                component={Home}
            />
            {
                routerList.map((item,index)=>{
                    return (
                        <Route 
                            key={index}
                            path={item.path}
                            exact={item.exact}
                            component={item.component}
                        />
                    )
                })
            }
            {/* <Redirect to='/' /> */}
            </NavigationBar>
        </Switch>
    )
}

export default IndexRouter